<div class="flex flex-col py-[8px]">
  <ng-container *ngFor="let step of featureSteps">
    <ng-container *ngFor="let workflow of step.workflows">
      @if (!workflow.isHidden) {
        <lib-stepper-item
          [option]="workflow" 
          [activeStepper]="activeStepper">
        </lib-stepper-item>
      }
    </ng-container>
  </ng-container>
</div>
